import { render, staticRenderFns } from "./HrContractUpdate.vue?vue&type=template&id=35b7946f&lang=pug&"
import script from "./HrContractUpdate.vue?vue&type=script&lang=js&"
export * from "./HrContractUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrContractUpdate.vue"
export default component.exports